"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _imageSrc = require("../../lib/imageSrc");
var _CardFooter = _interopRequireDefault(require("../../components/CardFooter"));
var _utils = require("../../utils");
var _linkFieldSrc = require("../../lib/linkFieldSrc");
var _richTextField = require("../../lib/richTextField");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _lodash = require("lodash");
var _titleHeadTag = require("../../lib/titleHeadTag");
var _reactBootstrap = require("react-bootstrap");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 *  A react component to create a Media Horizontal card
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering Fields to render
 * @param {object} props.rendering.fields Fields
 *
 * @returns {React.ReactElement} A Media card with wide, square and round image
 */
function MediaHorizontalCard(props) {
  if (!props.rendering.fields || (0, _lodash.isEmpty)(props.rendering.fields.MediaImage.value)) {
    return null;
  }
  var extractedFields = (0, _utils.extractFieldsFn)(props);
  var {
    linkUrl,
    linkTarget,
    linkAlt
  } = (0, _linkFieldSrc.linkFieldSrc)(extractedFields.Link.value);
  var mediaAlignment = extractedFields.MediaAlignment.value === 'right' ? 'media-right' : 'media-left';
  var mediaImageType = (0, _lodash.isEmpty)(extractedFields.MediaImageType.value) ? 'square' : extractedFields.MediaImageType.value;
  var MediaImage = props => {
    var mediaItemSize = (0, _lodash.isEmpty)(extractedFields.MediaItemSize.value) ? 'xl' : extractedFields.MediaItemSize.value;
    'xl';
    var imageType = mediaImageType === 'wide' ? 'mm-img' : mediaImageType === 'round' ? "mm-img-circle--".concat(mediaItemSize) : "mm-img-square--".concat(mediaItemSize);
    return /*#__PURE__*/_react.default.createElement("picture", {
      className: imageType
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: (0, _imageSrc.imageHref)(props.MediaImage.value),
      alt: props.MediaImage.value.alt
    }));
  };
  var MediaBody = props => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "body"
    }, !(0, _lodash.isEmpty)(props.Eyebrow.value) && /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Label, null, props.Eyebrow.value), !(0, _lodash.isEmpty)(props.Title.value) && (0, _titleHeadTag.headTagTitle)(props.Title, 'card-title', props.TitleSize.value), !(0, _lodash.isEmpty)(props.PreviewText.value) && /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Text, null, (0, _richTextField.parseHTML)(props.PreviewText)), /*#__PURE__*/_react.default.createElement(MediaFooter, props));
  };
  var MediaFooter = props => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_CardFooter.default, {
      buttonType: props.ButtonType.value,
      linkUrl: linkUrl,
      linkTarget: linkTarget,
      linkAlt: linkAlt,
      buttonTxt: props.Text.value,
      ctaIcon: props.ctaIcon.value,
      ctaIconDirection: props.ctaIconPlacement.value,
      callOut: (0, _richTextField.parseHTML)(props.Callout),
      ctaDataId: props.ctaDataId.value
    }));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    id: (0, _utils.getComponentContentId)(props.rendering.dataSource),
    className: "app-container media-horizontal"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, {
    variant: extractedFields.Variant.value
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(mediaImageType === 'wide' ? 'mm-media-object--wide' : 'mm-media-object', " ").concat(mediaAlignment)
  }, /*#__PURE__*/_react.default.createElement(MediaBody, extractedFields), /*#__PURE__*/_react.default.createElement(MediaImage, extractedFields)))))));
}
var _default = exports.default = MediaHorizontalCard;